import { Injectable } from '@angular/core';
import { Fetch } from '@syncfusion/ej2-base';
import { DataManager, Query, UrlAdaptor } from '@syncfusion/ej2-data';
import { ConfigService } from '../services/config/config.service';
import { LocalStorageTokenService } from '../services/utilisateurs/local-storage-token.service';

@Injectable({
  providedIn: 'root',
})
export class JwtUrlAdaptor extends UrlAdaptor {
  constructor(
    private localStorage: LocalStorageTokenService,
    private configService: ConfigService
  ) {
    super();
  }

  override processQuery(dm: DataManager, query: Query, hierarchyFilters?: Object[]): Object {
    const request = super.processQuery(dm, query, hierarchyFilters);


    if (request && request['type'] === 'POST') {
      let data = request['data'] ? JSON.parse(request['data']) : {};
      const params = new URLSearchParams();

      for (const key of Object.keys(data)) {
        if(key === 'requiresCounts'){
          continue;
        }
        params.append(key, data[key]);
      }

      return {
        type: 'GET',
        url: dm.dataSource['url'] + (params.toString() ? '?' + params.toString() : ''),
        data: null,
        pvtData: request['pvtData'] ?? {}
      };
    }
    return request;
  }


  override beforeSend(dm: DataManager, request: Request, settings: Fetch): void {
    const token = this.localStorage.getCurrentToken()?.value;
    const authz = this.localStorage.getCurrentAuthorizationToken()?.value;

    const headers = new Headers(request.headers ?? {});
    headers.set('Content-Type', 'application/json; charset=utf-8');
    if (token) headers.set('Authorization', `Bearer ${token}`);
    if (this.configService.isFusionAuthConfigured() && authz) {
      headers.set('Authorizations', authz);
    }

    const requestInit: RequestInit = {
      method: request.method,
      headers,
    };

    if (request.body) {
      requestInit.body = request.body;
      (requestInit as any).duplex = 'half';
    }

    try {
      settings.fetchRequest = new Request(request.url, requestInit);
    } catch (err) {
      console.error('Erreur dans fetchRequest :', err);
    }
  }

}
